var geojson={北京市:[116.46,39.92],
    '北京市':[116.46,39.92],
    '北京':[116.46,39.92],
    '平谷区':[117.1,40.13],
    '密云区':[116.85,40.37],
    '顺义区':[116.65,40.13],
    '通州区':[116.66,39.91],
    '怀柔区':[116.62,40.32],
    '大兴区':[116.33,39.73],
    '房山区':[115.98,39.72],
    '延庆区':[115.97,40.47],
    '昌平区':[116.2,40.22],
    '海淀区':[116.31,39.96],
    '朝阳区':[116.49,39.92],
    '石景山区':[116.19,39.91],
    '西城区':[116.37,39.91],
    '东城区':[116.41,39.92],
    '丰台区':[116.29,39.86],
    '门头沟区':[116.11,39.94],
    
    '上海市':[121.48,31.22],
    '上海':[121.48,31.22],
    '嘉定区':[121.25,31.38],
    '宝山区':[121.49,31.40],
    '奉贤区':[121.46,30.92],
    '松江区':[121.24,31],
    '金山区':[121.16,30.89],
    '青浦区':[121.11,31.15],
    '崇明区':[121.40,31.63],
    '浦东新区':[121.57,31.25],
    '普陀区':[121.39,31.24],
    '静安区':[121.45,31.23],
    '虹口区':[121.49,31.26],
    '杨浦区':[121.52,31.27],
    '黄浦区':[121.49,31.22],
    '长宁区':[121.42,31.22],
    '徐汇区':[121.44,31.18],
    '闵行区':[121.38,31.11],
    
    '天津市':[117.2,39.13],
    '天津':[117.2,39.13],
    '宁河区':[117.83,39.33],
    '蓟州区':[117.41,40.05],
    '宝坻区':[117.31,39.72],
    '武清区':[117.06,39.37],
    '北辰区':[117.13,39.23],
    '红桥区':[117.16,39.18],
    '河北区':[117.20,39.16],
    '南开区':[117.16,39.12],
    '和平区':[117.19,39.12],
    '河东区':[117.23,39.12],
    '河西区':[117.22,39.10],
    '东丽区':[117.31,39.09],
    '西青区':[117.01,39.14],
    '津南区':[117.38,38.99],
    '滨海新区':[117.65,39.03],
    '静海区':[116.93,38.94],
    
    '重庆市':[106.54,29.59],
    '重庆':[106.54,29.59],
    '綦江区':[106.56,29.41],
    '长寿区':[106.64,29.01],
    '南桐区':[107.04,29.86],
    '合川区':[106.28,29.26],
    '潼南区':[106.22,30.03],
    '铜梁区':[105.8,30.16],
    '壁山区':[106.03,29.86],
    '荣昌区':[106.21,29.62],
    '大足区':[105.59,29.4],
    '永川区':[105.71,29.75],
    '万盛区':[105.91,29.38],
    '城口县':[108.6649,31.946293],
    '巫溪县':[109.628912,31.3966],
    '巫山县':[109.878928,31.074843],
    '奉节县':[109.465774,31.019967],
    '云阳县':[108.697698,30.930529],
    '开州区':[108.413317,31.167735],
    '万州区':[108.380246,30.807807],
    '梁平区':[107.800034,30.672168],
    '忠县':[108.037518,30.291537],
    '垫江县':[107.348692,30.330012],
    '石柱土家族自治县':[108.112448,29.99853],
    '黔江区':[108.782577,29.527548],
    '酉阳土家族苗族自治县':[108.767201,28.839828],
    '秀山土家族苗族自治县':[108.996043,28.444772],
    '彭水苗族土家族自治县':[108.166551,29.293856],
    '武隆区':[107.75655,29.32376],
    '涪陵区':[107.394905,29.703652],
    '南川区':[107.098153,29.156646],
    '大渡口区':[106.48613,29.481002],
    '北碚区':[106.437868,29.82543],
    '沙坪坝区':[106.4542,29.541224],
    '九龙坡区':[106.480989,29.523492],
    '渝北区':[106.512851,29.601451],
    '南川区':[107.098153,29.156646],
    '江津区':[106.253156,29.283387],
    '江北区':[106.532844,29.575352],
    '南岸区':[106.560813,29.523992],
    '巴南区':[106.519423,29.381919],
    '渝中区':[106.56288,29.556742],
    '赤峰市':[118.956806,42.275317],
    
    '西藏自治区':[91.11,29.97],
    '拉萨市':[91.132212,29.660361],
    '阿里地区':[80.105498,32.503187],
    '山南市':[91.766529,29.236023],
    '昌都市':[97.178452,31.136875],
    '日喀则市':[88.885148,29.267519],
    '那曲市':[92.060214,31.476004],
    '林芝市':[94.362348,29.654693],
    
    '新疆维吾尔自治区':[87.68,43.77],
    '乌鲁木齐市':[87.617733,43.792818],
    '克拉玛依市':[84.873946,45.595886],
    '吐鲁番市':[89.184078,42.947613],
    '哈密市':[93.51316,42.833248],
    '昌吉回族自治州':[87.304012,44.014577],
    '博尔塔拉蒙古自治州':[82.074778,44.903258],
    '巴音郭楞蒙古自治州':[86.150969,41.768552],
    '阿克苏地区':[80.265068,41.170712],
    '克孜勒苏柯尔克孜自治州':[76.172825,39.713431],
    '喀什地区':[75.989138,39.467664],
    '和田地区':[79.92533,37.110687],
    '伊犁哈萨克自治州':[81.317946,43.92186],
    '塔城地区':[82.985732,46.746301],
    '阿勒泰地区':[88.13963,47.848393],
    '石河子市':[86.041075,44.305886],
    '阿拉尔市':[81.285884,40.541914],
    '图木舒克市':[79.077978,39.867316],
    '五家渠市':[87.526884,44.167401],
    '北屯市':[87.824932,47.353177],
    '铁门关市':[85.501218,41.827251],
    '双河市':[82.353656,44.840524],
    '可克达拉市':[80.63579,43.6832],
    '昆玉市':[79.287372,37.207994],
    '胡杨河市':[84.8275959,44.69288853],
    
    '甘肃省':[103.73,36.03],
    '兰州市':[103.823557,36.058039],
    '临夏回族自治州':[103.212006,35.599446],
    '金昌市':[102.187888,38.514238],
    '张掖市':[100.455472,38.932897],
    '酒泉市':[98.510795,39.744023],
    '定西市':[104.626294,35.579578],
    '甘南藏族自治州':[102.911008,34.986354],
    '白银市':[104.173606,36.54568],
    '陇南市':[104.929379,33.388598],
    '天水市':[105.724998,34.578529],
    '庆阳市':[107.638372,35.734218],
    '嘉峪关市':[98.277304,39.786529],
    '武威市':[102.634697,37.929996],
    '平凉市':[106.684691,35.54279],
    
    '陕西省':[108.95,34.27],
    '西安市':[108.948024,34.263161],
    '汉中市':[107.028621,33.077668],
    '咸阳市':[108.705117,34.333439],
    '榆林市':[109.741193,38.290162],
    '安康市':[109.029273,32.6903],
    '延安市':[109.49081,36.596537],
    '宝鸡市':[107.14487,34.369315],
    '商洛市':[109.939776,33.868319],
    '渭南市':[109.502882,34.499381],
    '铜川市':[108.979608,34.916582],
    
    '四川省':[104.06,30.67],
    '成都市':[104.065735,30.659462],
    '自贡市':[104.773447,29.352765],
    '攀枝花市':[101.716007,26.580446],
    '泸州市':[105.443348,28.889138],
    '德阳市':[104.398651,31.127991],
    '绵阳市':[104.741722,31.46402],
    '广元市':[105.829757,32.433668],
    '遂宁市':[105.571331,30.513311],
    '内江市':[105.066138,29.58708],
    '乐山市':[103.761263,29.582024],
    '南充市':[106.082974,30.795281],
    '眉山市':[103.831788,30.048318],
    '宜宾市':[104.630825,28.760189],
    '广安市':[106.633369,30.456398],
    '达州市':[107.502262,31.209484],
    '雅安市':[103.001033,29.987722],
    '巴中市':[106.753669,31.858809],
    '资阳市':[104.641917,30.122211],
    '阿坝藏族羌族自治州':[102.221374,31.899792],
    '甘孜藏族自治州':[101.963815,30.050663],
    '凉山彝族自治州':[102.258746,27.886762],
    
    '广西壮族自治区':[108.33,22.84],
    '南宁市':[108.320004,22.82402],
    '柳州市':[109.411703,24.314617],
    '桂林市':[110.299121,25.274215],
    '梧州市':[111.297604,23.474803],
    '北海市':[109.119254,21.473343],
    '防城港市':[108.345478,21.614631],
    '钦州市':[108.624175,21.967127],
    '贵港市':[109.602146,23.0936],
    '玉林市':[110.154393,22.63136],
    '百色市':[106.616285,23.897742],
    '贺州市':[111.552056,24.414141],
    '河池市':[108.062105,24.695899],
    '来宾市':[109.229772,23.733766],
    '崇左市':[107.353926,22.404108],
    
    '河南省':[113.65,34.76],
    '郑州市':[113.665412,34.757975],
    '开封市':[114.341447,34.797049],
    '洛阳市':[112.434468,34.663041],
    '平顶山市':[113.307718,33.735241],
    '安阳市':[114.352482,36.103442],
    '鹤壁市':[114.295444,35.748236],
    '新乡市':[113.883991,35.302616],
    '焦作市':[113.238266,35.23904],
    '濮阳市':[115.041299,35.768234],
    '许昌市':[113.826063,34.022956],
    '漯河市':[114.026405,33.575855],
    '三门峡市':[111.194099,34.777338],
    '南阳市':[112.540918,32.999082],
    '商丘市':[115.650497,34.437054],
    '信阳市':[114.075031,32.123274],
    '周口市':[114.649653,33.620357],
    '驻马店市':[114.024736,32.980169],
    '济源市':[112.590047,35.090378],
    
    // 内蒙古
    '内蒙古自治区':[111.65,40.82],
    '赤峰市': [118.956806, 42.275317],
    '呼伦贝尔市': [119.758168, 49.215333],
    '兴安盟': [122.070317, 46.076268],
    '呼和浩特市': [111.670801, 40.818311],
    '包头市': [109.840405, 40.658168],
    '乌海市': [106.825563, 39.673734],
    '通辽市': [122.263119, 43.617429],
    '鄂尔多斯市': [109.99029, 39.817179],
    '巴彦淖尔市': [107.416959, 40.757402],
    '乌兰察布市': [113.114543, 41.034126],
    '锡林郭勒盟': [116.090996, 43.944018],
    '阿拉善盟': [105.706422, 38.844814],
    
    // 吉林省
    '吉林省':[125.35,43.88],
    '长春市': [125.3245, 43.886841],
    '吉林市': [126.55302, 43.843577],
    '四平市': [124.370785, 43.170344],
    '辽源市': [125.145349, 42.902692],
    '通化市': [125.936501, 41.721177],
    '白山市': [126.427839, 41.942505],
    '松原市': [124.823608, 45.118243],
    '白城市': [122.841114, 45.619026],
    '延边朝鲜族自治州': [129.513228, 42.904823],
    
    // 浙江省
    '浙江省':[120.19,30.26],
    '杭州市': [120.153576, 30.287459],
    '宁波市': [121.549792, 29.868388],
    '温州市': [120.672111, 28.000575],
    '嘉兴市': [120.750865, 30.762653],
    '湖州市': [120.102398, 30.867198],
    '绍兴市': [120.582112, 29.997117],
    '金华市': [119.649506, 29.089524],
    '衢州市': [118.87263, 28.941708],
    '舟山市': [122.106863, 30.016028],
    '台州市': [121.428599, 28.661378],
    '丽水市': [119.921786, 28.451993],
    
    // 江西
    '江西省':[115.89,28.68],
    '南昌市': [115.892151, 28.676493],
    '景德镇市': [117.214664, 29.29256],
    '萍乡市': [113.852186, 27.622946],
    '九江市': [115.992811, 29.712034],
    '新余市': [114.930835, 27.810834],
    '鹰潭市': [117.033838, 28.238638],
    '赣州市': [114.940278, 25.85097],
    '吉安市': [114.986373, 27.111699],
    '宜春市': [114.391136, 27.8043],
    '抚州市': [116.358351, 27.98385],
    '上饶市': [117.971185, 28.44442],
    
    // 湖北
    '湖北省':[114.31,30.52],
    '武汉市': [114.298572, 30.584355],
    '黄石市': [115.077048, 30.220074],
    '十堰市': [110.787916, 32.646907],
    '宜昌市': [111.290843, 30.702636],
    '襄阳市': [112.144146, 32.042426],
    '鄂州市': [114.890593, 30.396536],
    '荆门市': [112.204251, 31.03542],
    '孝感市': [113.926655, 30.926423],
    '荆州市': [112.23813, 30.326857],
    '黄冈市': [114.879365, 30.447711],
    '咸宁市': [114.328963, 29.832798],
    '随州市': [113.37377, 31.717497],
    '仙桃市': [113.453974, 30.364953],
    '潜江市': [112.896866, 30.421215],
    '天门市': [113.165862, 30.653061],
    '恩施土家族苗族自治州': [109.4869983114,30.28311400],
    '神农架林区': [110.671525, 31.74444],
    
    // 广东
    '广东省':[113.23,23.16],
    '广州市': [113.280637, 23.125178],
    '韶关市': [113.591544, 24.801322],
    '深圳市': [114.085947, 22.547],
    '珠海市': [113.553986, 22.224979],
    '汕头市': [116.708463, 23.37102],
    '佛山市': [113.122717, 23.028762],
    '江门市': [113.094942, 22.590431],
    '湛江市': [110.364977, 21.274898],
    '茂名市': [110.919229, 21.659751],
    '肇庆市': [112.472529, 23.051546],
    '惠州市': [114.412599, 23.079404],
    '梅州市': [116.117582, 24.299112],
    '汕尾市': [115.364238, 22.774485],
    '河源市': [114.697802, 23.746266],
    '阳江市': [111.975107, 21.859222],
    '清远市': [113.051227, 23.685022],
    '东莞市': [113.746262, 23.046237],
    '中山市': [113.382391, 22.521113],
    '潮州市': [116.632301, 23.661701],
    '揭阳市': [116.355733, 23.543778],
    '云浮市': [112.044439, 22.929801],
    
    // 贵州
    '贵州省':[106.71,26.57],
    '贵阳市': [106.713478, 26.578343],
    '遵义市': [106.937265, 27.706626],
    '六盘水市': [104.846743, 26.584643],
    '安顺市': [105.932188, 26.245544],
    '毕节市': [105.28501, 27.301693],
    '铜仁市': [109.191555, 27.718346],
    '黔西南布依族苗族自治州': [104.897971, 25.08812],
    '黔东南苗族侗族自治州': [107.977488, 26.583352],
    '黔南布依族苗族自治州': [107.517156, 26.258219],
    
    // 青海
    '青海省':[101.74,36.56],
    '西宁市': [101.778916, 36.623178],
    '海东市': [102.10327, 36.502916],
    '海北藏族自治州': [100.901059, 36.959435],
    '黄南藏族自治州': [102.019988, 35.517744],
    '海南藏族自治州': [100.619542, 36.280353],
    '果洛藏族自治州': [100.242143, 34.4736],
    '玉树藏族自治州': [97.008522, 33.004049],
    '海西蒙古族藏族自治州': [97.370785, 37.374663],
    
    // 辽宁
    '辽宁省':[123.38,41.8],
    '沈阳市': [123.429096, 41.796767],
    '大连市': [121.618622, 38.91459],
    '鞍山市': [122.995632, 41.110626],
    '抚顺市': [123.921109, 41.875956],
    '本溪市': [123.770519, 41.297909],
    '丹东市': [124.383044, 40.124296],
    '锦州市': [121.135742, 41.119269],
    '营口市': [122.235151, 40.667432],
    '阜新市': [121.648962, 42.011796],
    '辽阳市': [123.18152, 41.269402],
    '盘锦市': [122.06957, 41.124484],
    '铁岭市': [123.844279, 42.290585],
    '朝阳市': [120.451176, 41.576758],
    '葫芦岛市': [120.856394, 40.755572],
     
    // 江苏
    '江苏省':[118.78,32.04],
    '南京市': [118.767413, 32.041544],
    '无锡市': [120.301663, 31.574729],
    '徐州市': [117.184811, 34.261792],
    '常州市': [119.946973, 31.772752],
    '南通市': [120.864608, 32.016212],
    '苏州市': [120.619585, 31.299379],
    '连云港市': [119.178821, 34.600018],
    '淮安市': [119.021265, 33.597506],
    '盐城市': [120.139998, 33.377631],
    '扬州市': [119.421003, 32.393159],
    '镇江市': [119.452753, 32.204402],
    '泰州市': [119.915176, 32.484882],
    '宿迁市': [118.275162, 33.963008],
    
    // 安徽
    '安徽省':[117.27,31.86],
    '合肥市': [117.283042, 31.86119],
    '芜湖市': [118.376451, 31.326319],
    '蚌埠市': [117.363228, 32.939667],
    '淮南市': [117.018329, 32.647574],
    '马鞍山市': [118.507906, 31.689362],
    '淮北市': [116.794664, 33.971707],
    '铜陵市': [117.816576, 30.929935],
    '安庆市': [117.043551, 30.50883],
    '黄山市': [118.317325, 29.709239],
    '滁州市': [118.316264, 32.303627],
    '阜阳市': [115.819729, 32.896969],
    '宿州市': [116.984084, 33.633891],
    '六安市': [116.507676, 31.752889],
    '亳州市': [115.782939, 33.869338],
    '池州市': [117.489157, 30.656037],
    '宣城市': [118.757995, 30.945667],
     
    // 河北省'
    '河北省':[114.48,38.03],
    '石家庄市':[114.48,38.03],
    '唐山市':[118.02,39.63],
    '秦皇岛市':[119.57,39.95],
    '邯郸市':[114.47,36.6],
    '邢台市':[114.48,37.05],
    '保定市':[115.48,38.85],
    '张家口市':[114.87,40.82],
    '承德市':[117.93,40.97],
    '沧州市':[116.83,38.33],
    '廊坊市':[116.7,39.53],
    '衡水市':[115.72,37.72],
    
    // 山西省'
    '山西省':[112.53,37.87],
    '太原市':[112.53,37.87],
    '大同市':[113.3,40.12],
    '阳泉市':[113.57,37.85],
    '长治市':[113.08,36.18],
    '晋城市':[112.83,35.52],
    '朔州市':[112.43,39.33],
    '晋中市':[112.74,37.7],
    '运城市':[110.97,35.03],
    '忻州市':[112.73,38.42],
    '临汾市':[111.5,36.08],
    '吕梁市':[111.13,37.52],
    
    // 黑龙江省'
    '黑龙江省':[126.63,45.75],
    '哈尔滨市':[126.63,45.75],
    '齐齐哈尔市':[123.97,47.33],
    '鹤岗市':[130.3,47.33],
    '鸡西市':[130.97,45.3],
    '双鸭山市':[131.17,46.65],
    '大庆市':[125.03, 46.58],
    '伊春市':[128.92,47.73],
    '佳木斯市':[130.35,46.83],
    '七台河市':[130.83,45.82],
    '牡丹江市':[129.58,44.6],
    '黑河市':[127.53,50.22],
    '绥化市':[127,46.63],
    '大兴安岭地区':[124.71,52.34],
    
    // 福建省'
    '福建省':[119.3,26.08],
    '福州市':[119.3,26.08],
    '厦门市':[118.1,24.46],
    '莆田市':[119,25.44],
    '三明市':[117.61,26.23],
    '泉州市':[118.58,24.93],
    '漳州市':[117.35,24.52],
    '南平市':[118.16,26.65],
    '龙岩市':[117.01,25.12],
    '宁德市':[119.52,26.65],
    
    // 山东省'
    '山东省':[117,36.65],
    '济南市':[117,36.65],
    '青岛市':[120.33,36.07],
    '淄博市':[118.05,36.78],
    '枣庄市':[117.57,34.86],
    '东营市':[118.49,37.46],
    '烟台市':[121.39,37.52],
    '潍坊市':[119.1,36.62],
    '济宁市':[116.59,35.38],
    '泰安市':[117.13,36.18],
    '威海市':[122.1,37.5],
    '日照市':[119.46,35.42],
    '临沂市':[118.35,35.05],
    '德州市':[116.29,37.45],
    '聊城市':[115.97,36.45],
    '滨州市':[118.03,37.36],
    '菏泽市':[115.47,35.25],
    
    // 湖南省'
    '湖南省':[113,28.21],
    '长沙市':[113,28.21],
    '株洲市':[113.16,27.83],
    '湘潭市':[112.91,27.87],
    '衡阳市':[112.61,26.89],
    '邵阳市':[111.5,27.22],
    '岳阳市':[113.09,29.37],
    '常德市':[111.69,29.05],
    '张家界市':[110.48,29.13],
    '益阳市':[112.33,28.6],
    '郴州市':[113,25.79],
    '永州市':[111.63,26.22],
    '怀化市':[109.95,27.52],
    '娄底市':[111.96,27.71],
    '湘西土家族苗族自治州':[109.74,28.31],
    
    // 海南省'
    '海南省':[110.35,20.02],
    '海口市':[110.35,20.02],
    '三亚市':[109.51,18.25],
    '三沙市':[112.35,16.83],
    '儋州市':[109.58,19.52],
    '五指山市':[109.52,18.78],
    '琼海市':[110.46,19.25],
    '文昌市':[110.72,19.61],
    '万宁市':[110.39,18.8],
    '东方市':[108.64,19.09],
    '定安县':[110.31,19.68],
    '屯昌县':[110.1,19.36],
    '澄迈县':[110,19.75],
    '临高县':[109.69,19.91],
    '白沙黎族自治县':[109.44,19.23],
    '昌江黎族自治县':[109.03,19.25],
    '乐东黎族自治县':[109.17,18.73],
    '陵水黎族自治县':[110.02,18.48],
    '保亭黎族苗族自治县':[109.7,18.64],
    '琼中黎族苗族自治县':[109.83,19.05],
    
    // 云南省'
    '云南省':[102.73,25.04],
    '昆明市':[102.73,25.04],
    '曲靖市':[103.79,25.51],
    '玉溪市':[102.52,24.35],
    '保山市':[99.17,25.11],
    '昭通市':[103.7,29.32],
    '丽江市':[100.25,26.86],
    '普洱市':[101.03,23.07],
    '临沧市':[100.09,23.89],
    '楚雄彝族自治州':[101.54,25.01],
    '红河哈尼族彝族自治州':[102.42,23.35],
    '文山壮族苗族自治州':[104.24,23.37],
    '西双版纳傣族自治州':[100.80,22.00],
    '大理白族自治州':[100.19,25.69],
    '德宏傣族景颇族自治州':[98.58,24.44],
    '怒江傈僳族自治州':[98.85,25.85],
    '迪庆藏族自治州':[99.71,27.83],
    
    // 宁夏
    '宁夏回族自治区':[106.27,38.47],
    '银川市':[106.27,38.47],
    '石嘴山市':[106.39,39.04],
    '吴忠市':[106.21,37.99],
    '固原市':[106.28,36.01],
    '中卫市':[105.18,37.51],
    }; 
				export default geojson;